import { render, staticRenderFns } from "./CodebreakerButtons.vue?vue&type=template&id=c2423060&"
import script from "./CodebreakerButtons.vue?vue&type=script&lang=js&"
export * from "./CodebreakerButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports